import React from 'react';
import { Route } from 'react-router-dom';
import DashboardCards from '../dashboard/DashboardCards';
import DashboardReports from '../dashboard/DashboardReports';
import DashboardGraphs from '../dashboard/DashboardGraphs';

export default [
  <Route exact path="/dashboard" component={DashboardCards} />,
  <Route exact path="/dashboard/reports" component={DashboardReports} />,
  <Route exact path="/dashboard/graphs" component={DashboardGraphs} />,
];



// WEBPACK FOOTER //
// ./src/resources/custom-routes/CustomRoutes.jsx